import Swiper, { Pagination, Manipulation } from "swiper";
import { addToGlobalThisRet } from "@plugins";

const selectionDefaultBreakpoints = {
    406: {
        slidesPerView: 2,
    },
    567: {
        slidesPerView: 3,
    },
    768: {
        shortSwipes: false,
        slidesPerView: 4,
    },
    992: {
        shortSwipes: false,
        slidesPerView: 4,
    },
};

class Selection {
    constructor(selection) {
        this.selection = selection;
        this.sliderContainer = this.selection.querySelector(".js-selection-slider");
        this.showAllLink = this.selection.querySelector(".js-selection-show-all");
        this.controls = [];
        this.breakpoints = selectionDefaultBreakpoints;

        this._init();
    }

    _init() {
        this._findControls();
        this._initSlider();
    }

    _findControls() {
        const controls = this.selection.querySelector(".js-selection-controls");

        if (controls) {
            this.controls = {
                buttonPrev: controls.querySelector(".swiper-button-prev"),
                buttonNext: controls.querySelector(".swiper-button-next"),
                pagination: controls.querySelector(".swiper-pagination"),
            };
        }
    }

    _initSlider() {
        const swiperOptions = {
            modules: [Pagination, Manipulation],
            slidesPerView: 1.9,
            preventClicks: false,
            pagination: {
                el: this.controls.pagination,
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
                type: "progressbar",
            },
            navigation: {
                prevEl: this.controls.buttonPrev,
                nextEl: this.controls.buttonNext,
            },
            observer: true,
            observeParents: true,
            watchOverflow: true,

            breakpoints: this.breakpoints,
        };

        if (this.sliderContainer) {
            this.slider = new Swiper(this.sliderContainer, swiperOptions);
        }

        if (window.mobileMedia) {
            this._initShowAllSlide();
        }
    }

    _initShowAllSlide() {
        if (this.showAllLink) {
            const slideLink = document.createElement("div");

            slideLink.classList.add("swiper-slide");
            slideLink.style.height = "auto";
            slideLink.appendChild(this.showAllLink);

            this.slider.appendSlide(slideLink);
        }
    }
}

function initSelections() {
    const selections = document.querySelectorAll(".js-selection");

    if (selections) {
        for (const selection of selections) {
            initSelectionsIntersectionObserver(selection);
        }
    }
}

function initSelectionsIntersectionObserver(selection) {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    new Selection(selection);
                    observer.unobserve(selection);
                }
            });
        },
        {
            rootMargin: "0px 0px 250px 0px",
            threshold: 0,
        },
    );

    observer.observe(selection);
}

initSelections();
addToGlobalThisRet(initSelections, "initSelections");
